import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showTutorial: true, 
};

const videoTutorialSlice = createSlice({
  name: "videoTutorial",
  initialState,
  reducers: {
    setTutorialVisibility: (state, action) => {
      state.showTutorial = action.payload;
    },
  },
});

export const { setTutorialVisibility } = videoTutorialSlice.actions;
export default videoTutorialSlice.reducer;
